import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiGrid } from 'react-icons/fi';

const CategoryCard = ({ 
  category, 
  isSelected = false, 
  onClick,
  showAsAll = false 
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(category.id);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full flex items-center justify-between p-4 bg-white rounded-xl transition-all ${
        isSelected
          ? 'border-2 border-blue-500 shadow-md'
          : 'border border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md'
      }`}
    >
      <div className="flex items-center gap-3">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden ${
          showAsAll ? 'bg-gradient-to-br from-blue-500 to-purple-500' : 'bg-gray-100'
        }`}>
          {showAsAll ? (
            <FiGrid className="w-6 h-6 text-white" />
          ) : category.feature_image ? (
            <img
              src={category.feature_image}
              alt={category.type}
              className="w-8 h-8 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<div class="w-8 h-8 rounded bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-sm">' + category.type.charAt(0) + '</div>';
              }}
            />
          ) : (
            <div className="w-8 h-8 rounded bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-sm">
              {category.type.charAt(0)}
            </div>
          )}
        </div>
        <span className="text-base font-semibold text-gray-900 text-left">
          {showAsAll ? 'All Courses' : category.type}
        </span>
      </div>
      <FiChevronRight className="w-5 h-5 text-gray-400 flex-shrink-0" />
    </button>
  );
};

export default CategoryCard;
